import { render, staticRenderFns } from "./ProductCollection.vue?vue&type=template&id=a959aad6&scoped=true"
import script from "./ProductCollection.vue?vue&type=script&lang=js"
export * from "./ProductCollection.vue?vue&type=script&lang=js"
import style0 from "./ProductCollection.vue?vue&type=style&index=0&id=a959aad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a959aad6",
  null
  
)

export default component.exports